<template>
    <v-app>
        <v-container fluid>
            <template v-if="$insertAccess($route.path)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel" >
                                <v-expansion-panel>
                                    <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header"><span>{{ isEntryMode ? "Add New Asset" : "Update New Asset" }}</span></v-expansion-panel-title>
                                        <v-expansion-panel-text> 
                                            <v-row class="py-2 no-gutters justify-space-around">
                                                <v-col lg="4" md="4" cols="12">
                                            <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="asset_code.value.value"
                                                    :error-messages="asset_code.errorMessage.value"
                                                    clearable
                                                    >
                                                        <template #label>
                                                            Asset Code
                                                        </template>
                                                    </v-text-field>
                                                    <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="name.value.value"
                                                    :error-messages="name.errorMessage.value"
                                                    clearable
                                                    >
                                                        <template #label>
                                                            Name <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-text-field>
                                                      <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="specification.value.value"
                                                    :error-messages="specification.errorMessage.value"
                                                    clearable
                                                    >
                                                        <template #label>
                                                            Specification
                                                        </template>
                                                    </v-text-field>

                                                     <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="model.value.value"
                                                    :error-messages="model.errorMessage.value"
                                                    clearable
                                                    >
                                                        <template #label>
                                                            Model
                                                        </template>
                                                    </v-text-field>

                                                    <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="asset_category_id.value.value"
                                                    :error-messages="asset_category_id.errorMessage.value"
                                                    clearable
                                                    :items="getAssetCategoryList"
                                                    :item-title="item => `${item.name}`"   
                                                    autocomplete="off"                                               
                                                    item-value="id"
                                                    :loading="categoryLoading"
                                                    >
                                                        <template #label>
                                                            Category <span class="text-red-accent-4">*</span>
                                                        </template> 
                                                    </v-autocomplete>

                                                    <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="asset_location_id.value.value"
                                                    :error-messages="asset_location_id.errorMessage.value"
                                                    clearable
                                                    :items="getAssetLocationsList"
                                                    :item-title="item => `${item.name}`"   
                                                    autocomplete="off"                                               
                                                    item-value="id"
                                                    :loading="locationLoading"
                                                    >
                                                        <template #label>
                                                            Location <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-autocomplete>

                                                    <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="asset_depreciation_method_id.value.value"
                                                    :error-messages="asset_depreciation_method_id.errorMessage.value"
                                                    clearable
                                                    :items="getAssetDepreciationMethodList"
                                                    :item-title="item => `${item.name}`"   
                                                    autocomplete="off"                                               
                                                    item-value="id"
                                                    :loading="depreciationMethodLoading"
                                                    >
                                                        <template #label>
                                                            Depreciation Method <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-autocomplete>



                                                    <v-text-field  
                                                    label="Total Units"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="total_units.value.value"
                                                    :error-messages="total_units.errorMessage.value"
                                                    :disabled="disable_field"
                                                    clearable
                                                    >
                                                        <template #label>
                                                                Total Units <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-text-field>

                                                    <v-text-field  
                                                    label="Per Period Unit"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="per_period_unit.value.value"
                                                    :error-messages="per_period_unit.errorMessage.value"
                                                    :disabled="disable_field"
                                                    clearable
                                                    >
                                                        <template #label>
                                                            Per Period Unit<span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-text-field>
                                                    
                                                    <v-text-field  
                                                    label="Units Used"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    :disabled="disable_field"
                                                    v-model="units_used.value.value"
                                                    :error-messages="units_used.errorMessage.value"
                                                    clearable
                                                    ></v-text-field>

                                                </v-col>
                                                
                                                <v-col lg="4" md="4" cols="12">
                                                                                                                                                        <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="asset_status_id.value.value"
                                                    :error-messages="asset_status_id.errorMessage.value"
                                                    clearable
                                                    :items="getAssetStatusTypesList"
                                                    :item-title="item => `${item.name}`"   
                                                    item-value="id"
                                                    :loading="statusTypeLoading"
                                                    >
                                                        <template #label>
                                                            Asset Status <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-autocomplete>

                                                    <v-text-field   
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="useful_life.value.value"
                                                    :error-messages="useful_life.errorMessage.value"
                                                    clearable
                                                    >
                                                        <template #label>
                                                            Useful Life <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-text-field>

                                                    <v-text-field  
                                                    label="Purchase Cost"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="purchase_cost.value.value"
                                                    :error-messages="purchase_cost.errorMessage.value"
                                                    clearable
                                                    >
                                                        <template #label>
                                                            Purchase Cost <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-text-field>

                                                    <v-autocomplete
                                                    label="Brand"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="brand_id.value.value"
                                                    :error-messages="brand_id.errorMessage.value"
                                                    clearable
                                                    :items="getBrandList"
                                                    :item-title="item => `${item.name}`"   
                                                    autocomplete="off"             
                                                    item-value="id"
                                                    :loading="brandLoading"
                                                    ></v-autocomplete>

                                                    <v-autocomplete
                                                    label="Supplier"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="supplier_id.value.value"
                                                    :error-messages="supplier_id.errorMessage.value"
                                                    clearable
                                                    :items="getSupplierList"
                                                    :item-title="item => `${item.supplier_name}`"   
                                                    autocomplete="off"                                               
                                                    item-value="id"
                                                    :loading="supplierLoading"
                                                    ></v-autocomplete>

                                                    <v-text-field   
                                                    label="Book Value Start"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="book_value_start.value.value"
                                                    :error-messages="book_value_start.errorMessage.value"
                                                    clearable
                                                    ></v-text-field>

                                                    <v-text-field  
                                                    label="Quantity"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="quantity.value.value"
                                                    :error-messages="quantity.errorMessage.value"
                                                    clearable
                                                    ></v-text-field>
                                                    <v-text-field  
                                                    label="Recoverable Amount"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="recoverable_amount.value.value"
                                                    :error-messages="recoverable_amount.errorMessage.value"
                                                    clearable
                                                    ></v-text-field>
                                                </v-col>

                                                

                                                <v-col lg="4" md="4" cols="12">
                                                    <v-date-input
                                                    input-format="dd/mm/yyyy"
                                                    class="px-2"
                                                    label="Purchase Date"
                                                    density="compact"
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-calendar"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="purchase_date.value.value"
                                                    :error-messages="purchase_date.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                    ></v-date-input>

                                                    <v-date-input
                                                    input-format="dd/mm/yyyy"
                                                    label="Depreciation Start Date"
                                                    density="compact"
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-calendar"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="depreciation_start_date.value.value"
                                                    :error-messages="depreciation_start_date.errorMessage.value"
                                                    autocomplete="off"
                                                    class="px-2"
                                                    clearable
                                                    ></v-date-input>
                                                    
                                                    <v-text-field  
                                                    label="Warranty Month"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="warranty_month.value.value"
                                                    :error-messages="warranty_month.errorMessage.value"
                                                    clearable
                                                    ></v-text-field>

                                                    <v-text-field
                                                    label="Salvage Value"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="salvage_value.value.value"
                                                    :error-messages="salvage_value.errorMessage.value"
                                                    clearable
                                                    ></v-text-field>

                                                    <v-file-input
                                                    v-model="selectedImage"
                                                    label="Register Image"
                                                    accept="image/*"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    persistent-hint
                                                    hint="Image must be exactly 120px × 120px"
                                                    show-size
                                                    @input="previewImage"                               
                                                    @click:clear="clearImage"
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-camera"
                                                    class="ellipsis-filename px-2"
                                                    title="image"
                                                    >                                                                                                  
                                                    </v-file-input>

                                                    <div class="px-2" style="float: right;">
                                                        <v-img :src="preview" cover  class="preview-image"></v-img>
                                                    </div>

                                                </v-col>
                                            </v-row>

                                            <v-divider></v-divider>
                                            <v-card-actions>
                                                <v-row class="pt-2">
                                                    <v-col cols="8">
                                                        <v-textarea
                                                        label="Remarks"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        v-model="remarks.value.value"
                                                        :error-messages="remarks.errorMessage.value"
                                                        autocomplete="off"
                                                        rows="3"
                                                        clearable
                                                        ></v-textarea>
                                                    </v-col>
                                                    <v-col cols="4">
                                                        <v-layout class="justify-end">
                                                        <v-btn
                                                            class="bg-grey-darken-1 me-2"
                                                            variant="flat"
                                                            @click="submitForm(0)"
                                                            >DRAFT</v-btn
                                                        >
                                                        <v-btn
                                                            class="bg-primary"
                                                            variant="flat"
                                                            @click="submitForm(1)"
                                                            >POST</v-btn
                                                        >
                                                        </v-layout>
                                                    </v-col>
                                                    </v-row>
                                            </v-card-actions>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-form>
                </template>
            </v-container>
        </v-app>
</template>

<script>

import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import { useRouter } from 'vue-router'; 
import { fileServerUrl } from "@/store/api";
import formattedDate from '@/plugins/dateFormatter';

const DEFAULT_IMAGE = '/src/assets/no_preview.jpeg';

export default {
        components: {},
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            supplierLoading: false,
            brandLoading:false,
            depreciationMethodLoading:false,
            categoryLoading:false,
            locationLoading:false,
            statusTypeLoading:false,
            disable_field: true,
            search: "",
            data: {},
            preview: '/src/assets/no_preview.jpeg'
        }),
        watch: {
            'asset_depreciation_method_id.value.value'(newVal) {
                console.log('Depreciation method changed to:', newVal);
                if(newVal === 3) {
                    this.disable_field = false;
                }else{
                    this.disable_field = true;
                }
            }
        },
        created(){
            if(this.$store.getters.getSupplierList.length == 0){
                this.supplierLoading = true;
                this.$store.dispatch('getSupplierList').then((response) => {
                    this.supplierLoading = false;
                })
            };
            if(this.$store.getters.getBrandList.length == 0){
                this.brandLoading = true;
                this.$store.dispatch('getBrandList').then((response) => {
                    this.brandLoading = false;
                })
            };
            if(this.$store.getters.getAssetDepreciationMethodList.length == 0){
                this.depreciationMethodLoading = true;
                this.$store.dispatch('getAssetDepreciationMethodList').then((response) => {
                    this.depreciationMethodLoading = false;
                })
            };
            if(this.$store.getters.getAssetCategoryList.length == 0){
                this.categoryLoading = true;
                this.$store.dispatch('getAssetCategoryList').then((response) => {
                    this.categoryLoading = false;
                })
            };
            if(this.$store.getters.getAssetLocationsList.length == 0){
                this.locationLoading = true;
                this.$store.dispatch('getAssetLocationsList').then((response) => {
                    this.locationLoading = false;
                })
            };
            if(this.$store.getters.getAssetStatusTypesList.length == 0){
                this.statusTypeLoading = true;
                this.$store.dispatch('getAssetStatusTypesList').then((response) => {
                    this.statusTypeLoading = false;
                })
            };
        },
        computed:{
            getSupplierList(){
                let data = this.$store.getters.getSupplierList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getBrandList(){
                let data = this.$store.getters.getBrandList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getAssetDepreciationMethodList(){
                let data = this.$store.getters.getAssetDepreciationMethodList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getAssetCategoryList(){
                let data = this.$store.getters.getAssetCategoryList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getAssetLocationsList(){
                let data = this.$store.getters.getAssetLocationsList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getAssetStatusTypesList(){
                let data = this.$store.getters.getAssetStatusTypesList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
        },
        methods: {
            resetForm() {
                this.data = {};
                this.preview = '/src/assets/no_preview.jpeg';
                this.selectedImage = null;
            },
            previewImage: function(event) {
                this.selectedImage = event.target.files[0];
                const input = event.target;
                if (input.files && input.files[0]) {
                        var reader = new FileReader();
                        reader.onload = (e) => {
                        this.preview = e.target.result;
                    }
                    this.image = input.files[0];
                    reader.readAsDataURL(input.files[0]);
                }
                else {
                    this.preview = '/src/assets/no_preview.jpeg';
                }
            },
            clearImage() {
                this.preview = '/src/assets/no_preview.jpeg';
            },
        },

        setup() {
            const { handleSubmit, resetForm } = useForm({
                validationSchema: yup.object({
                    asset_code: yup.string().nullable().max(100).trim().label("Asset Code"),
                    specification: yup.string().nullable().max(255).trim().label("Specification"),
                    model: yup.string().nullable().max(255).trim().label("Model"),
                    name: yup.string().required().max(100).trim().label("Name"),
                    asset_category_id: yup.string().required().trim().label("Category"),
                    asset_location_id: yup.string().required().trim().label("Location"),
                    asset_depreciation_method_id: yup.string().required().trim().label("Depreciation Method"),
                    total_units: yup
                    .number()
                    .typeError("Total Units must be a number")
                    .when('asset_depreciation_method_id', {
                        is: (val) => Number(val) === 3,
                        then: (schema) => schema.required("Total Units is required for this depreciation method").integer().positive(),
                        otherwise: (schema) => schema.nullable(),
                    })
                    .label("Total Units"),
                    per_period_unit: yup
                    .number()
                    .typeError("Per Period Unit must be a number")
                    .when('asset_depreciation_method_id', {
                        is: (val) => Number(val) === 3,
                        then: (schema) => schema.required("Per Period Unit is required for this depreciation method").integer().positive(),
                        otherwise: (schema) => schema.nullable(),
                    })
                    .label("Per Period Unit"),
                    asset_status_id: yup.string().required().trim().label("Asset Status"),
                    useful_life: yup.number().typeError("Useful Life must be a number").required().positive().integer().label("Useful Life"),
                    purchase_cost: yup.number().typeError("Purchase Cost must be a number").required().min(0).label("Purchase Cost"),
                    supplier_id: yup.string().nullable().trim().label("Supplier"),
                    remarks: yup.string().max(250).nullable().trim().label("Remarks"),
                    depreciation_rate: yup.number().nullable().min(0).max(100).label("Depreciation Rate"),
                    salvage_value: yup.number().nullable().min(0).label("Salvage Value"),
                    warranty_month: yup.number().nullable().min(0).label("Warranty Month"),
                    purchase_date: yup.date().nullable().label("Purchase Date"),
                    depreciation_start_date: yup.date().nullable().label("Depreciation Start Date"),
                    quantity: yup.number().nullable().min(0).label("Quantity"),
                    recoverable_amount: yup.number().nullable().min(0).label("Recoverable Amount"),
                    book_value_start: yup.number().nullable().min(0).label("Book Value Start"),
                    units_used: yup.number().nullable().min(0).label("Units Used"),
                    brand_id: yup.string().nullable().label("Brand"),
                    // status: yup.number().nullable().label("Status"),
                    // image: yup.mixed().nullable().label("Image"),
                }),
            });


            const asset_register_id = useField('asset_register_id');
            const asset_code = useField('asset_code');
            const specification = useField('specification');
            const model = useField('model');
            const name = useField('name');
            const supplier_id = useField('supplier_id');
            const asset_category_id = useField('asset_category_id');
            const asset_location_id = useField('asset_location_id');
            const asset_depreciation_method_id = useField('asset_depreciation_method_id');
            const asset_status_id = useField('asset_status_id');
            const purchase_cost = useField('purchase_cost');
            const salvage_value = useField('salvage_value');
            const useful_life = useField('useful_life');
            const book_value_start = useField('book_value_start');
            const accumulated_depreciation = useField('accumulated_depreciation');
            const units_used = useField('units_used');
            const total_units = useField('total_units');
            const per_period_unit = useField('per_period_unit');
            const quantity = useField('quantity');
            const recoverable_amount = useField('recoverable_amount');
            const warranty_month = useField('warranty_month');
            const purchase_date = useField('purchase_date');
            const depreciation_start_date = useField('depreciation_start_date');
            const image = useField('image');
            const brand_id = useField('brand_id');
            const status = useField('status');
            const remarks = useField('remarks');
            
            const errorMessages  = ref('');
            const loading  = ref('');
            const selectedImage  = ref(null);
            const preview = ref(DEFAULT_IMAGE);
            const isEntryMode = ref(true);

            const store = useStore();
            const router = useRouter();

            const currentStatus = ref(0);

            const submitForm = (status) => {
                currentStatus.value = status;
                submit();
            };

            const submit = handleSubmit((values) => { 
                const formData = new FormData();
                values.purchase_date  = formattedDate(purchase_date.value.value);
                values.depreciation_start_date = formattedDate(depreciation_start_date.value.value);

                console.log(values)

                Object.keys(values).forEach((key) => {
                    formData.append(key, values[key] || "");
                });

                formData.append('status', currentStatus.value);
                if (selectedImage.value) {
                    formData.append('image', selectedImage.value); 
                }

                store.dispatch("saveUpdateAssetRegistration", formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }) 
                    .then((response) => {  
                        resetForm();
                        loading.value = false;
                        toast.success(response.data.message, {
                            timeout: 3000,
                        });
                        setTimeout(() => {
                            router.push({ name: "asset-records" });
                        }, 2000);
                    })
                    .catch((error) => { 
                        loading.value = false;
                        toast.error(error.response.data.message);      
                    })
            })
            return {
                submit,
                submitForm,
                asset_code,
                specification,
                model,
                name,
                asset_register_id,
                supplier_id,
                asset_category_id,
                asset_location_id,
                asset_depreciation_method_id,
                asset_status_id,
                purchase_cost,
                useful_life,
                book_value_start,
                accumulated_depreciation,
                units_used,
                total_units,
                per_period_unit,
                quantity,
                recoverable_amount,
                warranty_month,
                purchase_date,
                depreciation_start_date,
                image,
                brand_id,
                remarks,
                salvage_value,
                status,
                errorMessages,
                selectedImage,
                preview,
                isEntryMode,
                resetForm,
                loading
            }
        },
        mounted() {

            if (this.$store.getters.getEditingAssetRegistration) {
                const data = this.$store.getters.getEditingAssetRegistration;
                this.$store.commit('SET_LOADING', { color: 'primary' });
                
                this.isEntryMode = false;
                this.asset_register_id.value.value = data.id;
                this.asset_code.value.value = data.code 
                this.name.value.value = data.name
                this.specification.value.value = data.specification 
                this.model.value.value = data.model 
                this.supplier_id.value.value = data.supplier_id 
                this.asset_category_id.value.value = data.asset_category_id 
                this.asset_location_id.value.value = data.asset_location_id 
                this.asset_depreciation_method_id.value.value = data.asset_depreciation_method_id 
                this.asset_status_id.value.value = data.asset_status_id 
                this.purchase_cost.value.value = data.purchase_cost 
                this.useful_life.value.value = data.useful_life 
                this.book_value_start.value.value = data.book_value_start 
                this.accumulated_depreciation.value.value = data.accumulated_depreciation 
                this.units_used.value.value = data.units_used 
                this.total_units.value.value = data.total_units 
                this.per_period_unit.value.value = data.per_period_unit 
                this.quantity.value.value = data.quantity 
                this.recoverable_amount.value.value = data.recoverable_amount 
                this.warranty_month.value.value = data.warranty_month 
                this.purchase_date.value.value = data.purchase_date 
                this.depreciation_start_date.value.value = data.depreciation_start_date 
                this.brand_id.value.value = data.brand_id ;
                this.remarks.value.value = data.remarks 
                this.salvage_value.value.value = data.salvage_value 
                this.status.value.value = data.status === 1 ? 1 : 0; 
                if (data.image) {
                    this.image.value.value = data.image;
                    this.preview = data.image ? fileServerUrl + data.image : '/src/assets/no_preview.png';
                } else {
                    this.preview = DEFAULT_IMAGE;
                }

                this.$store.commit('UNSET_LOADING');
            }
        },
        beforeUnmount() {
            this.$store.commit('UNSET_EDITING_ASSET_REGISTRATION');
        }
    }
</script>